import React from 'react';
import {withStyles} from '@material-ui/core';
import i18n from '../../i18n';
import _ from 'lodash';
import Table from "@material-ui/core/Table";
import Paper from "@material-ui/core/Paper";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableRowClickable from "../Form/TableRowClickable";
import TableCell from "@material-ui/core/TableCell";
import Typography from "@material-ui/core/Typography/Typography";
import Popover from "@material-ui/core/Popover";

const projectStatus = async() => {



};

/**
 * Content of Start Page
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const BuildingList = (props) => {

    const {values,classes} = props;

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handlePopoverOpen = (event) => {
        //console.log(event.currentTarget);
        //setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        //console.log('close')
        //setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <Paper className={classes.paper}>
            {values.buildings && values.buildings.length > 0 ? (
            <Table className={classes.list}>
                <TableHead>
                    <TableRow>
                        <TableCell>{i18n.get('building.construction_project')}</TableCell>
                        <TableCell align={'center'}>{i18n.get('building.number_of_buildings')}</TableCell>
                        <TableCell align={'center'}>{i18n.get('building.number_of_projects')}</TableCell>
                        <TableCell align={'center'}>{i18n.get('building.status')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {values.buildings.map( (building,idx) => (
                        <TableRowClickable key={`building_${idx}`} action={`/construction/${building.id}`}>
                            <TableCell
                                key={'cell_'+idx}
                                aria-owns={open ? 'mouse-over-popover_' + idx : undefined}
                                aria-haspopup="true"
                                onMouseEnter={(e) => handlePopoverOpen(e)}
                                onMouseLeave={handlePopoverClose}
                            >
                                <Typography>
                                    {building.name}
                                </Typography>
                                <Popover key={'popover_'+ idx} id={ 'mouse-over-popover_' + idx }
                                         className={classes.popover}
                                         classes={{
                                             paper: classes.paper,
                                         }}
                                         open={open}
                                         anchorEl={anchorEl}
                                         anchorOrigin={{
                                             vertical: 'center',
                                             horizontal: 'right',
                                         }}
                                         transformOrigin={{
                                             vertical: 'bottom',
                                             horizontal: 'left',
                                         }}
                                         onClose={handlePopoverClose}
                                         disableRestoreFocus>

                                    <Typography>I use Popover.{idx}</Typography>
                                </Popover>
                            </TableCell>
                            <TableCell align={'center'}>
                                <Typography>
                                    {building.number_of_buildings && building.number_of_buildings}
                                </Typography>
                            </TableCell>
                            <TableCell align={'center'}>
                                <Typography>
                                    {building.number_of_projects && building.number_of_projects}
                                </Typography>
                            </TableCell>
                            <TableCell align={'center'}>
                                <Typography key={`status`}>
                                    {building.status.map( (status, index) =>
                                        <span key={`status_${index}`} style={{marginLeft:20,paddingLeft:3,borderLeft:`3px solid ${status.color}`}}>{status.name + ': ' + status.count}</span>
                                    )}
                                </Typography>
                            </TableCell>
                        </TableRowClickable>
                    ))}
                </TableBody>
            </Table>
            ) : ( <div> {'no data'} </div> )}
        </Paper>
    );
}

const styles = theme => ({
    span: {
        display: 'inline',
        margin: '0 5px',
    },
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
    list: {
        "& tr": {
            height:40,
        },
        "& td" : {
            paddingTop:0,
            paddingBottom:0,
        },
        "& a": {
            padding:2,
        }
    },
});

export default withStyles(styles)(BuildingList);
